import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Skeleton } from '@mui/material';
import { theme } from '../themes/theme';
export const CategoryChip = ({ categoryName, value, isLoading, skeletonSx, showAsInteger = false, }) => {
    let palette;
    switch (categoryName) {
        case 'remaining':
            palette = theme.palette.remaining;
            break;
        case 'taken':
            palette = theme.palette.approvedTaken;
            break;
        case 'approved':
            palette = theme.palette.approvedFuture;
            break;
        case 'pending':
            palette = theme.palette.pending;
            break;
        case 'entitlement':
            palette = theme.palette.primary;
            break;
        default:
            throw new Error(`Invalid category name ${categoryName}`);
    }
    const sharedSx = {
        margin: '0.3em',
        width: '2.5em',
        height: '2.5em',
    };
    const chipSx = {
        ...sharedSx,
        color: palette.contrastText,
        backgroundColor: palette.main,
        borderRadius: '15%',
        fontSize: '1em',
        '& .MuiChip-label': { paddingX: '2px' },
    };
    if (isLoading) {
        return _jsx(Skeleton, { variant: "rounded", sx: { ...sharedSx, ...skeletonSx } });
    }
    return (_jsx(Chip, { size: "medium", sx: chipSx, label: showAsInteger ? value : value.toFixed(1) }));
};
